import shop from '../../api/shop'
import _ from "lodash";

const state = () => ({
  all: [],
  selected: null, //keep id
  selectedShipment: null,
  deliveryAddress: null,
  pickupAddress: null,
  location: null,
  selecting : true,
  delivery_time_type: null, // Giao sớm nhất có thể / Hẹn giờ giao hàng
  delivery_time_date: null,
  delivery_time_hour: null,
  type: '',
});

const getters = {
  currentShipmentType: state =>{
    return (state.selected > 0 && state.all) ? state.all[state.selected - 1] : null;
  },
  currentLocation: state => state.location,
  shipmentType: state => state.type,
  allShipments: state =>{
    return state.all ? state.all : null;
  },

};

const actions = {
  getAllShipments ({ commit }) {
    shop.getShipments(shipment => {
      commit('setShipments', shipment)
    })
  },

  setSelected ({state, commit} ,id) {

    if (id) {
      const shipmentItem = state.all.find(item => item.id === id);

      if (shipmentItem) {
        commit('setSelected', id);
        console.log(shipmentItem);
        commit('setSelectedShipment', shipmentItem);
      }
    } else {
      commit('setSelected', null);
      commit('setSelectedShipment', null);
    }

  },

  setDeliveryAddress ({commit} , data) {
    commit('setDeliveryAddress', data);
  },


  setPickupAddress ({commit} , data) {
    commit('setPickupAddress', data);
  },

  setLocation ({commit} , data) {
    commit('setLocation', data);
  },

  setType ({commit} , data) {
    commit('setType', data);
  },

  resetState ({state, commit}) {
    //state.all= [];
    state.selected= null;
    state.selectedShipment= null;
    state.deliveryAddress= null;
    state.pickupAddress= null;
    state.location= null
  },

  setSelecting ({commit} , data) {
    commit('setSelecting', data);
  },
};
const mutations = {
  setShipments: (state, shipments) => (state.all = shipments),
  setDeliveryAddress: (state, data) => (state.deliveryAddress = data),
  setPickupAddress: (state, data) => (state.pickupAddress = data),
  setType: (state, data) => (state.type = data),

  setSelected(state, id) {
    state.selected = id
  },

  setSelectedShipment(state, data) {
    state.selectedShipment = data
  },
  setLocation: (state, data) => (state.location = data),
  setSelecting: (state, data) => (state.selecting = data),

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/shipments.js